import { type PartialDeep } from 'type-fest';

import {
  type RequestFormFilterKeys,
  type RequestFormFilters,
} from '@entities/merchant';

const FILTER_KEYS: RequestFormFilterKeys[] = [
  'decision',
  'decision_applied_at',
  'assigned_to',
];

const isMerchantsFiltersActive = (
  initial: RequestFormFilters,
  filter?: PartialDeep<RequestFormFilters>,
) => {
  if (!filter) return false;

  return FILTER_KEYS.some(
    (key) => JSON.stringify(filter[key]) !== JSON.stringify(initial[key]),
  );
};

export default isMerchantsFiltersActive;
